import types from './rpdTypes'

const setSpecialtyCodes = (items: []) => ({ type: types.RPD_SET_SPECIALTY_CODES, items })
const setDisciplines = (items: []) => ({ type: types.RPD_SET_DISCIPLINES, items })
const setFiles = (items: []) => ({ type: types.RPD_SET_FILES, items })

const rpdActions = {
    setSpecialtyCodes, // Загрузка направлений подготовки
    setDisciplines, // Загрузка дисциплин
    setFiles, // Загрузка файлов
}

export default rpdActions